import { render, staticRenderFns } from "./CreatePlusAppTemplateListPage.vue?vue&type=template&id=1450a79e&scoped=true&"
import script from "./CreatePlusAppTemplateListPage.vue?vue&type=script&lang=js&"
export * from "./CreatePlusAppTemplateListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1450a79e",
  null
  
)

export default component.exports